import { createFileRoute } from "@tanstack/react-router";

import { QuestionnaireSubmissionFill } from "src/questionnaire/QuestionnaireSubmissionFill";

export const Route = createFileRoute(
  "/_auth/_coach/questionnaires/$questionnaireId/submissions/$submissionId/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <QuestionnaireSubmissionFill />;
}
